// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2201p","fadeIn":"styles_fadeIn__1-qU4","content":"styles_content__3pVEa","icon":"styles_icon__-eg3y"};